import { Link, useNavigate, useParams } from "react-router-dom";
import { decodedText, downloadFile, encodedText, noImageHandle, RatingShow, showAlertMsg, showModel, stopBackgroundScroll } from "../../components/CommonMethod";
import { useContext, useEffect, useState } from "react";
import { Context } from "../../components/Context";
import _, { now } from "lodash";
import { ASSET_ENDPOINT, DOWNLOAD_WORKBOOK_NOTES, ENCRYPTED_KEY, fetchData, GET_FREE_WORKBOOK, RESTART_EXAM, SHOP_WORKBOOKS, SHOP_WORKBOOKS_FILTER_ITEM } from "../../components/Service";
import WorkbookFilter, { FilterTopic, TooltipMsg } from "../../components/WorkbookFilter";
import { format } from "date-fns";
import { PageNavigation } from "../../components/DataTable";
import Exam from "../../components/Exam";
import LearningOutcomes from "../../components/LearningOutcomes";
import WorkbookVideo from "./WorkbookVideo";


const PackageDetails = () => {
    window.document.title = "Shop Listing Details";

    const params = useParams()
    const [context] = useContext(Context)
    const [data, setData] = useState(null)
    const [workbookInfo, setWorkbookInfo] = useState('')
    const [currentPage, setCurrentPage] = useState(1)
    const [filterItem, setFilterItem] = useState('')
    const [listingIds, setListingIds] = useState('')
    const [filter, setFilter] = useState(now())
    const [outcomeData, setOutcomeData] = useState([])
    const [workbookAttemptType] = useState('workbook')
    const [loading, setLoading] = useState(false)
    const [video, setVideo] = useState(null)
    const navigate = useNavigate()

    useEffect(() => {
        try {
            const data = (JSON.parse(decodedText(params.id, ENCRYPTED_KEY)));
            fetchData(`${SHOP_WORKBOOKS_FILTER_ITEM}/${data.id}`, 'get', '', true, false, (res) => {
                if (res.records) {
                    setListingIds(res.records?.single_shop_listing_ids)
                    setFilterItem(res.records ?? [])
                }
            });
        } catch (error) {
            window.history.go(-1);
        }
    }, [params])


    const filterToggle = () => {
        document.getElementById('asideFilterBox').classList.toggle('active');
        stopBackgroundScroll("asideFilterBox");
    }

    useEffect(() => {

    }, [])

    useEffect(() => setCurrentPage(1), [filter])

    useEffect(() => {
        if (listingIds) {
            let formData = new FormData(document.getElementById('filterForm'))
            fetchData(`${SHOP_WORKBOOKS}?page=${currentPage}&shop_listing_ids=${listingIds}`, 'POST', formData, true, true, (res) => {
                if (res.records) {
                    setData(res.records ?? [])
                }
            });
        }
    }, [currentPage, filter, listingIds])

    const operationPerform = (data, action) => {
        let mode = data.workbook.exam_records.exam_mode
        if (action === 'restart') {
            fetchData(RESTART_EXAM, 'POST', { workbook_id: data.workbook.id, workbook_attempt_type: workbookAttemptType }, true, false, (res) => {
                if (res.records) {
                    navigate(`/workbook/${_.kebabCase(data.workbook && data.workbook.title)}/${mode}`, { state: { action: action, mode: mode, course: data.course, workbook: data.workbook, workbook_attempt_type: workbookAttemptType } })
                }
            });
        } else {
            navigate(`/workbook/${_.kebabCase(data.workbook && data.workbook.title)}/${mode}`, { state: { action: action, mode: mode, course: data.course, workbook: data.workbook, workbook_attempt_type: workbookAttemptType } })
        }
    }

    const tryNow = () => {
        setLoading(true)
        fetchData(GET_FREE_WORKBOOK, 'POST', { listing_id: workbookInfo.id }, true, false, (res) => {
            if (res.records) {
                setLoading(false)
                document.querySelector('#confirmation_modal [data-bs-dismiss="modal"]').click()
                showModel('examModal')
            } else {
                setLoading(false)
            }
        });
    }

    const tryFreeWorkbook = (item) => {
        if (context?.auth?.user_type === '2') {
            if (context.auth.group_details) {
                showAlertMsg({ error: 'This workbook is not assigned to you' })
            } else {
                if (filterItem?.own_workbooks?.includes(item.workbook.id)) {
                    setWorkbookInfo(item)
                    showModel('examModal')
                } else if (filterItem?.free_workbook) {
                    if (filterItem?.free_workbook?.workbook?.id === item.workbook.id) {
                        setWorkbookInfo(item)
                        showModel('examModal')
                    } else {
                        showAlertMsg({ error: `You have already tried the ${filterItem?.free_workbook?.workbook?.title} workbook` })
                    }
                } else {
                    setWorkbookInfo(item)
                    showModel('confirmation_modal')
                }
            }
        } else {
            showAlertMsg({ error: 'You need to log in as a student before try any free workbook' })
        }
    }

    const canAssessWorkbook = (item) => {
        if (filterItem?.own_workbooks?.includes(item.workbook.id) || filterItem?.free_workbook?.workbook?.id === item.workbook.id) return true;
        else return false;
    }

    const downloadNote = async (e, item) => {
        if (canAssessWorkbook(item) && item?.workbook.notes) {
            e.target.classList.add("disabled");
            await downloadFile(`${DOWNLOAD_WORKBOOK_NOTES}/${item.workbook.id}`, item.workbook.title);
            e.target.classList.remove("disabled");
        }
    }

    const instanceCheckout = (e) => {
        e.preventDefault()
        navigate(`/checkout?checkout_id=${encodedText(filterItem.shop_listing.id, ENCRYPTED_KEY)}`)
    }

    return (<>
        <section>
            <div className="container container-1180 py-5">
                <div className="row g-3">
                    <div className="col-lg-4 pe-lg-5">
                        <form id="filterForm">
                            <div className="aside-filter" id="asideFilterBox">
                                <div className="aside-innerfilter">
                                    <div className="d-flex d-lg-none align-items-center justify-content-between pb-3">
                                        <strong className="fs-17">Filter By</strong>
                                        <button type="button" className="btn" onClick={() => filterToggle()} title="Close"><svg className="icon ts-1p5"><use href="#icon_clear"></use></svg></button>
                                    </div>

                                    {filterItem?.module?.length > 0 && <WorkbookFilter filter={setFilter} module={filterItem.module} />}

                                    {filterItem?.question_type?.length > 0 && <>
                                        <h5 className="fs-18 text-uppercase fw-bold text-blue mt-5 mb-0">Question Type</h5>
                                        {filterItem.question_type.map((item, key) => <FilterTopic key={key} name="question_type[]" value={item.value} label={item.type} fun={() => setFilter(now)} />)}
                                    </>}

                                    {filterItem?.workbook_status?.length > 0 && <>
                                        <h5 className="fs-18 text-uppercase fw-bold text-blue mt-5 mb-0">Workbook Status</h5>
                                        {filterItem.workbook_status.map((item, key) => <FilterTopic key={key} name="workbook_status[]" value={item.value} label={item.type} fun={() => setFilter(now)} />)}
                                    </>}

                                    {filterItem?.exam_style?.length > 0 && <>
                                        <h5 className="fs-18 text-uppercase fw-bold text-blue mt-5 mb-0">Exam Styles</h5>
                                        {filterItem.exam_style.map((item, key) => <FilterTopic key={key} name="exam_style[]" value={item.value} label={item.type} fun={() => setFilter(now)} />)}
                                    </>}

                                </div>
                            </div>
                        </form>
                    </div>

                    <div className="col-lg-8 body-over_flowx pse-10px">
                        <div className="justify-content-between">
                            <div className="d-flex justify-content-between mb-4 mb-md-3 order-1">
                                <div>
                                    <h2 className="h3 fw-bold">Try any one workbook for free !!!</h2>
                                    <p>
                                        {context?.auth?.user_type === '2' && context.auth.group_details && <span className="d-block fw-bold text-green">You are a group student.</span>}
                                    </p>
                                </div>
                                <div>
                                    {/* {isPurchased && <button type="button" className="btn btn-yellow btn-lg text-nowrap" title="Purchased">Purchased</button>}
                                    {!isPurchased && (!context?.auth || (context?.auth?.user_type === '2' && !context.auth.group_details)) && <button type="button" onClick={instanceCheckout} className="btn btn-theme-primary btn-lg text-nowrap" title="Get Access Now">Get Access Now</button>} */}
                                    <Link to='/shop-list' className="btn btn-theme-primary white-space btn-lg w-100">Go to Shop</Link>
                                    <button type="button" className="btn btn-link d-lg-none" onClick={() => filterToggle()}>
                                        <svg className="icon ts-1p4"><use href="#icon_filter"></use></svg>
                                    </button>
                                </div>
                            </div>
                        </div>

                        {data?.data?.map((item, index) => {
                            return (
                                <div className="col-lg-12 mb-4" key={index}>
                                    <div className="card border-blue-hover rounded-3">
                                        <div className="card-body p-md-4 d-sm-flex">
                                            <div className="mmwh-180 d-sm-block shadow-md rounded-3 position-relative overflow-hidden me-3 me-md-3">
                                                <img src={item.image && ASSET_ENDPOINT + item.image} className="h-100 ratio w-100 hm-180 object-fit-cover" alt="Workbook" onError={noImageHandle} />
                                                {item?.workbook?.video_url && <>
                                                    {canAssessWorkbook(item) ? <>
                                                        <span className={`position-absolute play-btn bg-dark-purple  mb-2 top-50 start-50 translate-middle text-white fw-bold fs-14  gap-1 cursor-pointer ratio ratio-1x1 rounded-circle w-40  text-center cursor-pointer`} data-bs-target="#videoModal" data-bs-toggle="modal" onClick={() => setVideo(item.workbook?.video_url)}> <span className="w-40 d-flex align-items-center justify-content-center"><svg className="icon fs-16"><use href="#icon_play"></use></svg></span></span></> : <>
                                                        <span className={`position-absolute play-btn bg-dark-purple  mb-2 top-50 start-50 translate-middle text-white fw-bold fs-14  gap-1 cursor-pointer ratio ratio-1x1 rounded-circle w-40  text-center cursor-pointer opacity-50`}> <span className="w-40 d-flex align-items-center justify-content-center"><svg className="icon fs-16"><use href="#icon_play"></use></svg></span></span>
                                                    </>}
                                                </>}
                                                {item?.workbook?.notes && <span onClick={(e) => downloadNote(e, item)} className={`position-absolute translate-x-middle start-50 bottom-0 mb-2 text-white fw-bold rounded fs-14 d-flex align-items-center gap-1 cursor-pointer px-2 minw-30 py-1 me-2 mt-2 text-center bg-dark-purple cursor-pointer text-nowrap ${canAssessWorkbook(item) ? '' : 'opacity-50'}`}><svg className="icon fs-18"><use href="#icon_download"></use></svg> Study notes</span>}
                                            </div>
                                            <div className="d-block mt-3 mt-sm-0 w-100">
                                                <div className="d-flex align-items-center">
                                                    <RatingShow fontsize="fs-4" rating={item.workbook && item.workbook.exam_records && item.workbook.exam_records.status === 'completed' ? JSON.parse(item.workbook.exam_records.question_details) : '0'} />
                                                    <h6 className="ms-auto text-green bold mt-1  ps-2">{item.workbook && item.workbook.exam_records && item.workbook.exam_records.status === 'updated' && `Workbook updated on ${format(new Date(item.workbook.exam_records.updated_at), 'MM/dd/yyyy')}.`}</h6>
                                                </div>
                                                <h4 className="fw-bold workbook-heading-smallsize ">
                                                    {item.workbook && item.workbook.title} - {item?.course_topic?.topic_name}
                                                    {item.user_id && item.expired_on && <TooltipMsg message={`Workbook is valid till ${format(new Date(item.expired_on), 'MM/dd/yyyy')}.`} />}
                                                </h4>
                                                <span className="d-flex gap-2 pb-3">
                                                    <div className="circle-progress ratio ratio-1x1 mmwh-24">
                                                        <svg viewBox="0 0 36 36">
                                                            <path stroke="#eeeeee" strokeWidth="3" d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" />
                                                            {item.workbook && item.workbook.exam_records ?
                                                                <path strokeWidth="4" stroke="#1E90FF" id="fillStroke" strokeDasharray={`${((JSON.parse(item.workbook.exam_records.answer_details).length) * 100) / (item.workbook.exam_records.exam_mode === 'exam' ? item.workbook.exam_questions_count : item.workbook.practice_questions_count)}, 100`} d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" />
                                                                : <path strokeWidth="4" stroke="" id="fillStroke" strokeDasharray="0, 100" d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" />
                                                            }

                                                            <text x="18" y="21.2" fill="#1E90FF"></text>
                                                        </svg>
                                                    </div>
                                                    {item.workbook && item.workbook.exam_records ? <>
                                                        <span className="fw-normal">{JSON.parse(item.workbook.exam_records.answer_details).length} / {item.workbook.exam_records.exam_mode === 'exam' ? item.workbook.exam_questions_count : item.workbook.practice_questions_count} questions completed</span>
                                                    </> : <span className="fw-normal">{0} / {item.workbook && item.workbook.questions_count} questions completed</span>}
                                                </span>
                                                {item.workbook && item.workbook.exam_records && <p className="fw-normal">Last opened {item.workbook.exam_records.ago === 0 && 'Today'} {item.workbook.exam_records.ago === 1 && '1 day ago'} {item.workbook.exam_records.ago > 1 && `${item.workbook.exam_records.ago} days ago`}</p>}

                                                {item.workbook && item.workbook.exam_records ? <>
                                                    {(item.workbook.exam_records.status === 'completed' || item.workbook.exam_records.status === 'updated') && <button data-bs-target="#examModal" data-bs-toggle="modal" onClick={() => setWorkbookInfo(item)} className={`${item.workbook && item.workbook.questions_count > 0 ? '' : 'disabled'} btn btn-theme-primary w-70 w-sm-50`} title="Restart">Restart</button>}
                                                    {item.workbook.exam_records.status === 'in-progress' && <>
                                                        <button className={`${item.workbook && item.workbook.questions_count > 0 ? '' : 'disabled'} btn btn-outline-default`} title="Restart" onClick={() => operationPerform(item, 'restart')}>Restart</button>
                                                        <button className={`${item.workbook && item.workbook.questions_count > 0 ? '' : 'disabled'} btn btn-theme-primary w-70 w-sm-50 ms-2`} title="Resume Practice" onClick={() => operationPerform(item, 'resume')}>Resume Practice</button> </>
                                                    }
                                                </> : <button className={`${item.workbook && item.workbook.questions_count > 0 ? '' : 'disabled'} btn btn-theme-primary w-70 w-sm-50`} title="Start" onClick={() => tryFreeWorkbook(item)}>Start</button>}

                                                {item && item.workbook && <button type="button" className="btn btn-theme-primary text-nowrap ms-2" onClick={() => setOutcomeData([{ title: item.workbook.title, learning_outcomes: item.workbook.learning_outcomes }])} data-bs-toggle="modal" data-bs-target="#learningOutcomesModal" title="Learning outcomes">Learning outcomes</button>}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                        })}

                        {data?.data?.length === 0 && <div className="row mt-1"><h4 className="fw-bold my-3 text-danger">Workbook Not Found</h4></div>}
                        {data?.total > 0 && <PageNavigation active_page={data.current_page - 1} per_page={data.per_page} filter_recoards={data.total} setCurrentPage={setCurrentPage} />}
                    </div>
                </div>
            </div>
            <Exam data={workbookInfo} workbookAttemptType={workbookAttemptType}></Exam>
        </section>
        <LearningOutcomes record={outcomeData} />
        <WorkbookVideo video={video} />

        <div className="modal fade" id="confirmation_modal" tabIndex="-1">
            <div className="modal-dialog">
                <div className="modal-content overflow-hidden border border-2 border-primary rounded-4">
                    <div className="modal-body p-4">
                        <h4 className="fw-bold">Are you sure you want to try '<span className="text-primary">{workbookInfo?.workbook?.title}</span>' as a free workbook?</h4>
                    </div>
                    <div className="modal-footer justify-content-between px-4 pt-0 pb-4 border-0">
                        <button type="button" className="btn btn-outline-default btn-lg" data-bs-dismiss="modal">Cancel</button>
                        <button type="button" className="btn btn-theme-primary btn-lg minw-120" disabled={loading} onClick={tryNow}>Confirm</button>
                    </div>
                </div>
            </div>
        </div>
    </>)
}
export default PackageDetails;